import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoginComponent } from '../components/login/login.component';
import { ConfirmCodeComponent } from '../components/login/confirm-code/confirm-code.component';
import { NewPasswordRequiredComponent } from '../components/login/new-password-required/new-password-required.component';
import { ForgotPasswordComponent } from '../components/forgot-password/forgot-password.component';
import { ForgotPasswordConfirmComponent } from '../components/forgot-password/forgot-password-confirm.component';
import { LogService } from './log.service';
import { SessionStorageService } from './session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class RouterService {
  constructor(private router: Router,
    private log: LogService,
    private sessionStorage: SessionStorageService) {}
    
  gotoHome() {
    this.router.navigate(['']);
  }

  gotoLogin() {
    // If session expires while in a top-level window, redirect the top to the UUX login page
    if (window !== window.parent) {
      window.top.location.pathname = '/csp/mxuux/ui/login';
    } else {
      this.router.navigate(['login']);
    }
  }

  gotoLogout() {
    if (window !== window.parent) {
      window.top.location.pathname = '/csp/mxuux/ui/logout';
    } else {
      this.router.navigate(['logout']);
    }
  }

  gotoLogin_ConfirmCodeSMS() {
    this.router.navigate(['confirm-code-sms']);
  }

  gotoLogin_ConfirmCodeTOTP() {
    this.router.navigate(['confirm-code-totp']);
  }

  gotoLogin_NewPasswordRequired() {
    this.router.navigate(['new-password-required']);
  }

  gotoLogin_MfaSelfRegistration() {
    this.router.navigate(['mfa-self-registration']);
  }

  gotoLogin_PasswordExpired() {
    this.router.navigate(['password-expired']);
  }

  gotoForgotUsernameSuccess() {
    this.router.navigate(['forgot-username-success']);
  }

  gotoForgotPassword() {
    this.router.navigate(['forgot-password']);
  }

  gotoForgotPasswordConfirm() {
    this.router.navigate(['forgot-password-confirm']);
  }

  gotoForgotPasswordSuccess() {
    this.router.navigate(['forgot-password-success']);
  }

  gotoLogout_Success() {
    this.router.navigate(['logout-success']);
  }

  gotoAccess() {
    this.router.navigate(['mx-access']);
  }
}
